var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-card',[_c('div',{staticClass:"d-flex align-items-center justify-content-between w-100",staticStyle:{"height":"60px"}},[_c('h2',{staticClass:"h5 mb-4 mr-2"},[_vm._v(" "+_vm._s(_vm.$t('product.weight_product_shipping'))+" ")])]),(_vm.editForm)?_c(_setup.ReadOnly):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }